export const collisionCovergeCodes = [
  'PACollisionCov',
  'PACCollision_Ext',
  'BAS4COLLISION',
  'BASCOLLISION'
];

export const comprehensiveCoverageCodes = [
  'PAComprehensiveCov',
  'PACComprehensive_Ext',
  'BAS4COMPREHENSIVE',
  'BASCOMPREHENSIVE'
];
